import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NOOP } from '../utils';
export default (function (fetchAction, selector) {
    var dispatch = useDispatch();
    var data = useSelector(selector);
    var didInvalidate = data.didInvalidate;
    useEffect(function () {
        dispatch(fetchAction()).catch(NOOP);
    }, [dispatch, fetchAction, didInvalidate]);
    return data;
});
